var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Popover } from '@kiwicom/orbit-components/lib';
import { P } from '../UI-helpers/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { AlignedSelectionBox, DisplayBox, DisplayBoxWrapper, DropdownIconWrapper, SelectionBox, SelectionBoxWrapper, } from './styles';
import { generateTextColor, textFormatter } from './helpers';
import { TEXT_COLOR } from './constants';
var tuple = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args;
};
var size = tuple('extraSmall', 'large', 'small', 'medium', 'medium-2');
var DropDown = function (_a) {
    var size = _a.size, transparent = _a.transparent, defaultValue = _a.defaultValue, value = _a.value, icon = _a.icon, list = _a.list, listSuffix = _a.listSuffix, onChange = _a.onChange, alignedSelectionBox = _a.alignedSelectionBox;
    var _b = useState(false), isVisible = _b[0], setVisible = _b[1];
    var _c = useState(''), selectedItem = _c[0], setSelectedItem = _c[1];
    var UIActions = {
        popover: {
            open: function () {
                setVisible(true);
            },
            hide: function () {
                setVisible(false);
            },
        },
    };
    var actions = {
        selectItem: function (item) {
            setSelectedItem(item);
            onChange(item);
            UIActions.popover.hide();
        },
    };
    return (_jsx(DisplayBoxWrapper, __assign({ size: size }, { children: _jsx(Popover, __assign({ opened: isVisible, onOpen: UIActions.popover.open, onClose: UIActions.popover.hide, noPadding: true, content: _jsx(_Fragment, { children: alignedSelectionBox ? (_jsx(SelectionBoxWrapper, __assign({ size: size }, { children: list === null || list === void 0 ? void 0 : list.map(function (item, index) { return (_jsx(AlignedSelectionBox, __assign({ onClick: function () { return actions.selectItem(item); } }, { children: _jsx(P, __assign({ fontSize: 16, color: TEXT_COLOR }, { children: "".concat(textFormatter(item)).concat(listSuffix ? listSuffix : '') })) }), index)); }) }))) : (_jsx(SelectionBoxWrapper, __assign({ size: size }, { children: list === null || list === void 0 ? void 0 : list.map(function (item, index) { return (_jsx(SelectionBox, __assign({ onClick: function () { return actions.selectItem(item); } }, { children: _jsx(P, __assign({ fontSize: 16, color: TEXT_COLOR }, { children: "".concat(textFormatter(item)).concat(listSuffix ? listSuffix : '') })) }), index)); }) }))) }) }, { children: _jsxs(DisplayBox, __assign({ transparent: transparent }, { children: [icon, (function () {
                        if (value) {
                            return _jsx(P, { children: "".concat(value).concat(listSuffix ? listSuffix : '') });
                        }
                        return (_jsx(P, __assign({ fontSize: 16, color: generateTextColor(transparent) }, { children: selectedItem !== ''
                                ? "".concat(textFormatter(selectedItem)).concat(listSuffix ? listSuffix : '')
                                : "".concat(textFormatter(defaultValue)).concat(listSuffix ? listSuffix : '') })));
                    })(), _jsx(DropdownIconWrapper, { children: _jsx(FontAwesomeIcon, { icon: faCaretDown, color: generateTextColor(transparent) }) })] })) })) })));
};
export default DropDown;
